import React from "react";
import { Container } from "react-bootstrap";
import PublicHeader from "../components/Layout/PublicHeader";
import Footer from "../components/Layout/Footer";

const CGVPage = () => {
  return (
    <div className="cgv-page">
      <PublicHeader />
      <Container className="py-5">
        <h1 className="mb-4">Conditions générales de vente</h1>

        <div className="legal-content">
          <p>
            L'application mobile/ site internet, ci-après dénommée «le Service », est éditée par la société MARION (dénommée « le Vendeur » dans le cadre des présentes) SAS au capital de 30 000 euros, immatriculée au RCS de CANNES sous le numéro 987734472 et dont le siège social est sis 559 Chemin du Hameau de Plan Sarrain 06370 MOUANS-SARTOUX.
          </p>
          <p>
            MARION est une application mobile/ site internet ayant pour objet de proposer la vente et l'acheminement express des produits, matériaux et équipements pour le bâtiment (ci- après dénommés « les Produits ») à des acheteurs professionnels (ci-après dénommé «le(s) Client(s) » ).
          </p>

          <h2 className="mt-5 mb-3">DEFINITIONS</h2>
          <p>Dans le cadre des présentes conditions générales de vente, les termes ci-après doivent s'entendre dans le sens des définitions suivantes :</p>
          <ul>
            <li><strong>« CGV »</strong> désigne les présentes Conditions Générales de Vente ;</li>
            <li><strong>« Client »</strong> désigne, toute personne physique ou morale, publique ou privée, qui agit à des fins entrant dans le cadre de son activité commerciale, industrielle, artisanale, libérale ou agricole, y compris lorsqu'elle agit au nom et pour le compte d'un autre professionnel au sens de l'article liminaire du Code de la consommation et qui passe Commande auprès du Vendeur;</li>
            <li><strong>« Commande »</strong> désigne une demande d'achat effectuée par le Client et qui a été acceptée/confirmée par le Vendeur;</li>
            <li><strong>« Compte client »</strong> : désigne le compte personnel créé par le Client sur le Site lui permettant de passer Commande ;</li>
            <li><strong>« Destinataire »</strong> désigne la personne physique ou morale, mentionnée par le Client ou par son représentant, qui réceptionne les Produits et à laquelle la Livraison est faite ;</li>
            <li><strong>« Distributeur »</strong> désigne la personne morale qui distribue dans ses points de vente et magasins le(s Produit(s) mis en ligne sur le Site ;</li>
            <li><strong>« Livraison »</strong> désigne la remise physique du ou des Produits au(x) Client(s) ou à son représentant qui l'accepte;</li>
            <li><strong>« Partie(s) »</strong> désigne le Vendeur et/ou le Client;</li>
            <li><strong>« Prix »</strong> désigne le tarif du ou des Produits fixé par le Vendeur et accepté par le Client dans une Commande;</li>
            <li><strong>« Produit »</strong> désigne les objets, produits, matériaux et équipements pour le bâtiment qui font l'objet de la Commande;</li>
            <li><strong>« Vendeur »</strong> désigne la société Marion. Ces définitions couvrent à la fois les formes singulières et plurielles des termes définis.</li>
          </ul>

          <h2 className="mt-5 mb-3">1. Principes généraux</h2>
          <p>
            Les présentes Conditions Générales de Vente définissent les modalités des ventes en ligne conclues entre le Vendeur et tout Client effectuant un achat via le Service.
          </p>
          <p>
            Elles sont rédigées en français dans leur version originale qui seule fait foi et prévaut sur toute autre version. Les présentes Conditions Générales de Vente s'appliquent à l'exclusion de toutes autres conditions. Elles sont accessibles par le Client sur le Service à tout moment et elles sont systématiquement soumises au Client avant toute commande et au moment de l'enregistrement de la commande.
          </p>
          <p>
            Lors de la commande, le fait de cliquer sur le bouton « J'accepte les conditions générales de vente » manifeste le consentement du Client à l'application des présentes conditions générales de vente.
          </p>
          <p>
            En conséquence, le fait de passer commande implique l'adhésion entière et sans réserve du Client à ces Conditions Générales de Vente.
          </p>

          <h2 className="mt-5 mb-3">2. Modification des Conditions Générales de Vente en ligne</h2>
          <p>
            Compte tenu des évolutions possibles du Service, le Vendeur se réserve la possibilité d'adapter ou de modifier à tout moment les présentes Conditions Générales de Vente. En conséquence, le Vendeur invite le Client à consulter les Conditions Générales de Vente avant toute nouvelle commande. Les Conditions Générales de Vente alors en vigueur seront applicables à toutes les commandes passées à compter de leur date de mise en ligne.
          </p>

          <h2 className="mt-5 mb-3">3. Majorité légale et capacité</h2>
          <p>
            Le Client déclare être juridiquement capable de conclure le présent Contrat, dont les Conditions Générales de Vente sont présentées ci-après, c'est-à-dire avoir la majorité légale et ne pas être sous tutelle ou curatelle.
          </p>

          <h2 className="mt-5 mb-3">4. Produits</h2>
          <p>
            Les caractéristiques essentielles des Produits sont décrites pour chaque Produit sur le catalogue en ligne. Elles ont été présentées au Client préalablement à la commande, dans le cadre des informations précontractuelles qui lui ont été communiquées.
          </p>

          <h3 className="mt-4 mb-2">4.1. Caractéristiques des Produits</h3>
          <p>
            La liste des Produits présentés sur le Service est susceptible d'évoluer à tout moment pour mieux répondre aux besoins du Client.
          </p>
          <p>
            Les caractéristiques principales des Produits et notamment les spécifications, illustrations et indications de dimensions ou de capacité des Produits, sont présentées sur le Service et sont susceptibles d'être modifiées à tout moment.
          </p>

          <h3 className="mt-4 mb-2">4.2. Utilisation des Produits</h3>
          <p>
            Avant utilisation du Produit, le Client prend connaissance et veille à appliquer les précautions d'emploi et la notice d'utilisation, en particulier pour les Produits classés dangereux, et prend connaissance de la date limite d'utilisation pour les Produits périssables.
          </p>

          <h3 className="mt-4 mb-2">4.3. Conformité aux dispositions légales et réglementaires – Exportation</h3>
          <p>
            Les Produits sont conformes aux dispositions légales et réglementaires applicables en France. Il appartient au Client, qui en est seul responsable, de vérifier la conformité du Produit en cas d'exportation ou d'utilisation du Produit hors de France.
          </p>

          <h2 className="mt-5 mb-3">5. Compte Client</h2>
          <p>
            Afin de passer commande en ligne sur le Service, il est nécessaire de créer un Compte Client. Pour la création de son compte, il sera demandé au Client d'indiquer son nom, prénom, adresse de facturation, numéro de téléphone et le cas échéant numéro de SIRET et numéro de TVA intracommunautaire. À l'issue de la création de son Compte Client, un e-mail de confirmation récapitulant les informations renseignées est envoyé au Client sur l'adresse qu'il aura préalablement renseignée.
          </p>

          <h2 className="mt-5 mb-3">6. Commande</h2>
          <p>
            Le Client a reçu préalablement à la commande les informations visées à l'article L.111-1 du Code de la consommation, et notamment les caractéristiques essentielles des Produits ainsi que leur prix. Le Client effectue sa commande à partir du catalogue en ligne du Vendeur accessible sur le Service.
          </p>

          <h2 className="mt-5 mb-3">7. Confirmation de la commande</h2>
          <p>
            A l'issue de l'enregistrement d'une demande d'achat par le Client sur le Service et si cette demande est acceptée par le Vendeur, un accusé de réception détaillé de celle-ci lui est envoyé à son adresse e-mail qu'il aura préalablement renseignée.
          </p>

          <h2 className="mt-5 mb-3">8. Prix</h2>
          <p>
            Les prix de vente des Produits sont ceux figurant sur le Service au moment de la commande. Tout changement de prix postérieur à la commande est sans effet sur celle-ci.
          </p>
          <p>
            Les prix des produits sont indiqués en euros hors taxes et peuvent être soumis à des conditions ou à une durée de validité limitée. Le taux de la TVA applicable est celui en vigueur au moment de la passation de la Commande.
          </p>

          <h2 className="mt-5 mb-3">9. Paiement</h2>
          <p>
            Le paiement de la commande s'entend comptant au jour de la commande sur le site. Constitue un paiement au sens du présent article la mise effective des fonds à la disposition du Vendeur.
          </p>

          <h3 className="mt-4 mb-2">9.1 – Modalités de paiement</h3>
          <p>
            Le Client devra procéder au paiement en euros de la totalité du prix de sa commande par carte bancaire, sans escompte et au comptant, afin de valider cette dernière. Les Clients ont le choix entre deux modes de paiement lors de la passation de commande :
          </p>
          <ul>
            <li><strong>a) Paiement par Carte Bancaire :</strong> Les Utilisateurs peuvent régler leur commande par carte bancaire directement via l'Application mobile/ Site internet. Le débit n'est effectué qu'au moment de la validation de la commande.</li>
            <li><strong>b) Crédit Client :</strong> Les Clients ont la possibilité de créditer un compte client via l'Application mobile Site internet. Ce crédit peut être utilisé pour régler les commandes ultérieures de Services.</li>
          </ul>

          <h3 className="mt-4 mb-2">9.2. Sécurité des transactions</h3>
          <p>
            Afin d'optimiser la sécurité des transactions sur Internet, le Site utilise un système de paiement en ligne SSL (Secure Socket Layer) de telle sorte que tous les moyens sont mis en œuvre pour assurer la confidentialité et la sécurité des données transmises, dans le cadre d'un paiement en ligne.
          </p>

          <h2 className="mt-5 mb-3">10. Livraison</h2>
          <p>
            Les frais de livraison sont à la charge exclusive du Client. Ces frais sont forfaitaires et s'élèvent à 19,90€ HT pour toute Commande. La livraison est effectuée en France métropolitaine (hors Corse) uniquement.
          </p>

          <h2 className="mt-5 mb-3">11. Réception des Produits</h2>
          <p>
            Lors de la réception de la commande et avant le départ du livreur le Client doit procéder à l'ouverture et à la vérification du contenu du (des) colis livré(s), tant en ce qui concerne la conformité apparente que la quantité commandée.
          </p>

          <h2 className="mt-5 mb-3">12. Garantie</h2>
          <p>
            Le Client consommateur bénéficie de la garantie légale de conformité (articles L. 217-3 à L. 217-12 du code de la consommation) et de la garantie légale relative aux défauts de la chose vendue (articles 1641 à 1648 du code civil).
          </p>

          <h2 className="mt-5 mb-3">13. Responsabilité - Informations</h2>
          <p>
            Le Vendeur s'efforce d'assurer au mieux de ses possibilités l'exactitude et la mise à jour des informations diffusées sur le Service qu'il se réserve le droit de modifier, à tout moment et sans préavis.
          </p>

          <h2 className="mt-5 mb-3">14. Droit de rétractation</h2>
          <p>
            Conformément à l'article L. 221-18 du code de la consommation, le consommateur qui conclut un contrat par le biais d'un moyen de communication à distance dispose d'un délai de rétractation de quatorze (14) jours à compter de la date de réception du Produit pour revenir sur sa commande.
          </p>

          <h2 className="mt-5 mb-3">18. Force majeure</h2>
          <p>
            Le Vendeur dégage sa responsabilité pour tout manquement à ses obligations contractuelles dans l'hypothèse d'une force majeure ou fortuite, y compris, mais sans y être limitées, catastrophes, incendies, pandémie, grève interne ou externe, défaillance ou pannes internes ou externes, et d'une manière générale tout événement ne permettant pas la bonne exécution des commandes et des livraisons.
          </p>

          <h2 className="mt-5 mb-3">19. Loi applicable et juridiction compétente</h2>
          <p>
            Les présentes Conditions Générales sont soumises au droit interne français, exclusion faite de toute convention internationale.
          </p>
          <p>
            En cas de litige relatif aux présentes Conditions Générales ou à la vente, les parties essaieront dans la mesure du possible de résoudre leur litige à l'amiable.
          </p>
          <p>
            À défaut d'accord amiable, lorsque le Client est un consommateur, le Tribunal compétent est celui du lieu du domicile du défendeur ou celui de la livraison effective du Produit.
          </p>

          <h2 className="mt-5 mb-3">20. Recours à la médiation de la consommation</h2>
          <p>
            Si le Client est un « consommateur » au sens de l'article préliminaire du Code de la consommation, il doit en premier lieu adresser au Vendeur sa réclamation directement par le biais du formulaire de contact du Site en sélectionnant l'objet « Réclamation » ou à l'adresse suivante : contact@marion-livraison.com
          </p>
          <p>
            Si cette tentative échoue, il pourra recourir à une procédure de médiation de la consommation :
          </p>
          <p>
            <strong>Médiateur de la Fédération professionnelle du e-commerce et de la vente à distance (FEVAD)</strong><br />
            60 rue de la Boétie – 75008 PARIS<br />
            mediateurducommerce@fevad.com<br />
            <a href="https://www.mediateurfevad.fr" target="_blank" rel="noopener noreferrer">https://www.mediateurfevad.fr</a>
          </p>
        </div>
      </Container>
      <Footer />
    </div>
  );
};

export default CGVPage;
